import { useLogin } from "@/src/OS/Login/useLogin";
import { useNavigation } from "@react-navigation/native";
import { useIntl } from "react-intl";
import { MoreItem } from "@/src/common/navigationHeaderOptions";

export function useLoginMoreItem() {
  const navigation = useNavigation();
  const intl = useIntl();
  const [login] = useLogin();
  return {
    icon: "user-add",
    label: intl.formatMessage({
      defaultMessage: "Log in with another account on this device",
      description: "MyProfile:loginbutton:label",
    }),
    onPress: () => {
      login(() => {
        navigation.goBack();
      });
    },
  } as MoreItem;
}
